// extracted by mini-css-extract-plugin
module.exports = {"container":"_2UQIe8oh","checkList":"_2a_fJI9G","list":"_1zM2-Yyz","item":"_29vcrUM3","icon":"LPkraxjV","button":"_1kmdNe3s","headingText":"_2N4BZuay"};